import { createDomain, createStore, sample } from 'effector'
import { createGate } from 'effector-react'
import { AxiosErrorType, Driver } from '~/shared/api'
import { PaymentsTemplateDataType } from '~/shared/api/driver'
import { logger } from '~/shared/lib/logger'
import { snackbarEnqueued } from '~/shared/lib/notifications'

const domain = createDomain('features.workSchedule')

export const Gate = createGate()

export const getPaymentSchedule = domain.createEvent()
export const getPaymentScheduleFx = domain.createEffect<
  void,
  PaymentsTemplateDataType,
  AxiosErrorType
>({
  handler: Driver.getPaymentSchedule,
})

export const $paymentSchedule = createStore<PaymentsTemplateDataType | null>(
  null,
)
  .on(getPaymentScheduleFx.doneData, (_, data) => data)
  .on(getPaymentScheduleFx.failData, () => null)

sample({
  clock: Gate.open,
  target: getPaymentSchedule,
})

sample({
  clock: getPaymentSchedule,
  target: getPaymentScheduleFx,
})

sample({
  clock: getPaymentScheduleFx.failData,
  fn(e) {
    logger.error(e)
    return {
      message: 'Ошибка получения графика платежей',
      variant: 'danger' as const,
    }
  },
  target: snackbarEnqueued,
})
